import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IUserMast } from "../../models/UserMast";
import { ILogin, IPermissionProps } from "../../models/Login";
import { AttendanceHistoryTable } from "../attendanceMark/Table";

interface IProps {
    singledata: IMajorTech,
    open: boolean,
    hideHistory: () => void,
    toast: any,
    permissions?: IPermissionProps
}

export const AutoTeamAllocateHistory = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [attendanceTable, setAttendanceTable] = useState({ user_id: 0, open: false } as { user_id: number, open: boolean });


    const leftToolbarTemplate = () => {
        return <></>
    };

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const getHistory = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Requirement_CateGoryLInfo/getHistory", "GET", null, `CategoryID=${props.singledata.req_CategoryID}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data.length > 0 ? data : [], loading: false });
        }
    };
    const onHideHistoryTable = () => {
        setAttendanceTable({ user_id: 0, open: false });
    }

    const toggleVal = async (login_id: number, toggle_type: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("User_Mast/toggle", "PUT", null, `login_id=${login_id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            getHistory();
            // let message: string = toggle_type === 1 ? "User Status Changed" : toggle_type === 2 ? "Temp Status Changed" : "Work From Changed";
            let message: string = "User Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const user_TStatus = (rowData: IUserMast) => {
        return (
            <span style={{ color: rowData.temp_Inactive ? 'red' : 'green' }} className="cursor-pointer" onClick={() => { if (rowData.login_ID) toggleVal(rowData.login_ID, 2) }}>{rowData.temp_Inactive ? "No" : "Yes"}</span>
        );
    };

    const onHide = () => {
        props.hideHistory();
    }

    useEffect(() => {
        if (props.open) getHistory();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Allocation Order" modal className="p-fluid" onHide={onHide}>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                loading={tableData.loading}
            >
                <Column field="allocation_Order" header="Order" />
                <Column field="user_Name" header="Name" />
                <Column field="branchName" header="Branch" />
                <Column field="is_Allocate" header="Allocation" body={(e) => <p style={{ color: e.is_Allocate ? 'green' : 'red' }}>{e.is_Allocate ? "Yes" : "No"}</p>} />
                <Column field="temp_Inactive" header="Present" body={user_TStatus} />
                <Column field="user_Status" header="Status" body={(rowData) => <span style={{color: rowData.user_Status? 'red': 'green'}}>{rowData.user_Status ? "Inactive" : "Active"}</span>} />
                <Column header="History" body={(rowData) => <i className="cursor-pointer text-primary pi pi-clock" onClick={() => setAttendanceTable({ user_id: rowData.login_ID, open: true })}></i>} />
            </DataTable>
            <div className="field col-12 md:col-6 w-full">
                <Button className="p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
            </div>
            <Dialog visible={attendanceTable.open} style={{ width: '80vw' }} header="Allocation Order" modal className="p-fluid" onHide={onHideHistoryTable} >
                {props.permissions?.is_View && <AttendanceHistoryTable user_ID={attendanceTable.user_id} />}
            </Dialog>
        </Dialog>
    );
}